module.exports = __webpack_public_path__ + "img/wacc.99e4aa60.png";